import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { supabase } from '../supabase/client';
import { updateOtherUsersTest } from '../Redux/ovulationTestsSlice';

const TAG = '[TestsListener]';

/**
 * TestsListener - Subscribes to listenerUserIds and creates Supabase channel for other users
 * When listenerUserIds changes, creates/updates Supabase channel to listen to those users' tests
 * Updates Redux on INSERT/UPDATE events
 */
function TestsListener() {
  const dispatch = useDispatch();
  const listenerUserIds = useSelector((s) => s.ovulationTests.listenerUserIds);
  const channelRef = useRef(null);
  const currentIdsRef = useRef([]);

  useEffect(() => {
    // Only recreate channel if listenerUserIds actually changed
    const newIds = [...listenerUserIds].sort();
    const currentIds = [...currentIdsRef.current].sort();
    const idsChanged = JSON.stringify(newIds) !== JSON.stringify(currentIds);

    if (!idsChanged && channelRef.current) {
      return;
    }

    // Clean up previous channel
    if (channelRef.current) {
      supabase.removeChannel(channelRef.current);
      channelRef.current = null;
    }

    currentIdsRef.current = newIds;

    if (newIds.length === 0) {
      return;
    }

    // Create channel with OR filter for all user IDs
    const channelName = `ov-tests-listener-${newIds.join('-')}`;
    const ch = supabase
      .channel(channelName)
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'ovulation_tests' }, (payload) => {
        const userId = payload.new.user_id;
        if (newIds.includes(userId)) {
          dispatch(updateOtherUsersTest({ userId, test: payload.new }));
        }
      })
      .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'ovulation_tests' }, (payload) => {
        const userId = payload.new.user_id;
        if (newIds.includes(userId)) {
          dispatch(updateOtherUsersTest({ userId, test: payload.new }));
        }
      })
      .subscribe((status) => {
        // Channel status changed
      });

    channelRef.current = ch;

    return () => {
      if (channelRef.current) {
        supabase.removeChannel(channelRef.current);
        channelRef.current = null;
      }
      currentIdsRef.current = [];
    };
  }, [listenerUserIds, dispatch]);

  return null;
}

export default TestsListener;
